/* eslint-disable @typescript-eslint/no-unused-vars */
export function safeSessionStorageGetItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

export function safeSessionStorageSetItem(key: string, value: string): void {
  try {
    return sessionStorage.setItem(key, value);
  } catch (error) {
    return;
  }
}
